<template lang="pug">
.loaderOverlay(:class="{ filling: filling, fixed: fixed }")
  Skeletor(v-if="openingWindow", :height="'96%'", :width="'400px'", class="rounded-lg")
  .spinner(v-else)
</template>
<script>
export default {
  name: 'LoaderComponent',
  props: {
    filling: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    openingWindow: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.loaderOverlay {
  display: flex;
  justify-content: center;
  align-items: center;

  &.openingWindow {
    backdrop-filter: blur(2px);
  }

  &.filling {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: #333f48bf;
  }

  &.fixed {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #333f48bf;
    z-index: 1000;
  }
}

.vue-skeletor {
  background-color: #ffffffc5;
}
/* Shimmer */
.vue-skeletor:not(.vue-skeletor--shimmerless):after {
  background: linear-gradient(
    90deg,
    #ffffff00 0%,
    rgba(255, 255, 255, 1) 50%,
    #ffffff27 100%
  );
}

.spinner {
  width: 40px;
  height: 40px;
  display: grid;
  border-radius: 50%;
  -webkit-mask: radial-gradient(farthest-side, #0000 40%, #a2a2b5 41%);
  background:
    linear-gradient(
        0deg,
        rgba(162, 162, 181, 0.5) 50%,
        rgba(162, 162, 181, 1) 0
      )
      center/3.2px 100%,
    linear-gradient(
        90deg,
        rgba(162, 162, 181, 0.25) 50%,
        rgba(162, 162, 181, 0.75) 0
      )
      center/100% 3.2px;
  background-repeat: no-repeat;
  animation: spinner-d3o0rx 1s infinite steps(12);
}

.spinner::before,
.spinner::after {
  content: '';
  grid-area: 1/1;
  border-radius: 50%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}

.spinner::after {
  opacity: 0.83;
  transform: rotate(60deg);
}

@keyframes spinner-d3o0rx {
  100% {
    transform: rotate(1turn);
  }
}
</style>
